module.exports = __webpack_public_path__ + "img/Cart.7fc37ed3.svg";